module.exports = __webpack_public_path__ + "img/NewsCenterDetails7_pic11.96ce9781.png";